import { createAllSettledPolyfill } from './allSettled';

export const allSettled: PromiseConstructor['allSettled'] =
  // eslint-disable-next-line compat/compat
  'allSettled' in Promise ? Promise.allSettled.bind(Promise) : createAllSettledPolyfill();
